// extracted by mini-css-extract-plugin
export default {"wrapper":"p4-z","play":"q4-z"};